import { ClipboardDocumentListIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { useTaskNouns } from "hooks/use-task-nouns";
import React from "react";
import { WorkflowChipSource, workflowStepChips } from "./builder-helper";

interface SequenceStripProps {
    workflow: WorkflowChipSource;
}

export const SequenceStrip: React.FC<SequenceStripProps> = props => {
    const { workflow } = props;
    const nouns = useTaskNouns();
    const chips = workflowStepChips(workflow);

    if (chips.length === 0) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 flex-wrap">
            {chips.map((chip, index) => (
                <span
                    key={index}
                    className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-2.5 py-1 text-xs">
                    {chip.kind === "email" ? (
                        <EnvelopeIcon className="w-3.5 h-3.5 text-gray-500" />
                    ) : (
                        <ClipboardDocumentListIcon className="w-3.5 h-3.5 text-gray-500" />
                    )}
                    <span className="font-medium text-gray-700">
                        {chip.kind === "email" ? "Email" : nouns.titleSingular}
                    </span>
                    {chip.delayLabel ? (
                        <>
                            <span className="text-gray-300">&middot;</span>
                            <span className="text-gray-500">{chip.delayLabel}</span>
                        </>
                    ) : null}
                </span>
            ))}
        </div>
    );
};
